import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";
import GradientButton from "../../../input/GradientButton";

/**
 * Final mindful intention slide.
 * Asks what the first meaningful step is — input is optional.
 */
const IntentionStep = ({ taskName, value, onChange, onFinish }) => {
  return (
    <Box className="task-guide-step task-guide-step--intention">
      <AnimatedOrb size="medium" intensity="celebrating" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          What's the first meaningful step you can take towards{" "}
          <strong>{taskName}</strong>?
        </Typography>
      </SpeechBubble>

      <TextField
        multiline
        minRows={2}
        maxRows={4}
        placeholder="Just a thought. Whatever comes to mind."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        fullWidth
        sx={{
          mt: 2,
          mb: 3,
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "rgba(255,255,255,0.9)",
          },
        }}
      />

      <GradientButton text="Let's get started" onClick={onFinish} />
    </Box>
  );
};

export default IntentionStep;
